import { SUPPORT_INTENT_PATTERN, type BrowserInfo, type AiHistoryItem } from '@/types/support';

function getRandomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
    return bytes;
  }
  for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256);
  return bytes;
}

export function generateAccessToken(byteLength = 32): string {
  const bytes = getRandomBytes(byteLength);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function getBrowserInfo(): BrowserInfo {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return {
      userAgent: 'unknown',
      language: 'en',
      platform: 'unknown',
      screenWidth: 0,
      screenHeight: 0,
      timezone: 'UTC',
    };
  }
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform || 'unknown',
    screenWidth: window.screen?.width ?? 0,
    screenHeight: window.screen?.height ?? 0,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
  };
}

export function summarizeIssue(aiHistory: AiHistoryItem[], fallback?: string): string {
  const lastUser = [...aiHistory].reverse().find((m) => m.role === 'user');
  if (lastUser?.content?.trim()) {
    const t = lastUser.content.trim();
    return t.length > 180 ? `${t.slice(0, 177)}…` : t;
  }
  return fallback?.trim() || 'Customer requested human support from the chatbot.';
}

export function detectSupportIntent(text: string): boolean {
  return SUPPORT_INTENT_PATTERN.test(text);
}

export function parseUserAgent(ua: string): { browser: string; device: string } {
  const browser =
    /Edg\//.test(ua) ? 'Edge'
    : /Chrome\//.test(ua) ? 'Chrome'
    : /Firefox\//.test(ua) ? 'Firefox'
    : /Safari\//.test(ua) ? 'Safari'
    : 'Browser';
  const device =
    /Mobi|Android/i.test(ua) ? 'Mobile'
    : /Tablet|iPad/i.test(ua) ? 'Tablet'
    : 'Desktop';
  return { browser, device };
}
